import React, { useState } from 'react';
import { GenericModal } from 'web-ui-components/lib/layout/content';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { Content } from '../../infrastructure/content';

const GDPRExitModal = ({ backClick, toggleModel }) => {
  const [isExitModalOpen, toggleExitModal] = useState(true);
  return (
    <Content>
      {({
        gdprModalTitle,
        gdprModalDescription,
        gdprModalNoButtonLabel,
        gdprModalYesButtonLabel
      }) => (
        <GenericModal
          titleText={gdprModalTitle}
          onConfirm={() => {
            toggleExitModal(false);
            backClick();
          }}
          isOpen={isExitModalOpen}
          onClose={() => {
            toggleExitModal(false);
            toggleModel(false);
          }}
          dismissButtonText={gdprModalNoButtonLabel}
          confirmButtonText={gdprModalYesButtonLabel}
        >
          <StandardBody>
            <p>{gdprModalDescription}</p>
          </StandardBody>
        </GenericModal>
      )}
    </Content>
  );
};
export { GDPRExitModal };
